import { states } from "constants/states";
import { PROPERTY_ASSET_TYPES } from "@loanbossinc/component-library";

export const SponsorSampleData = new Array(57).fill({ name: "Connor", value: "Connor Value" });
const StatesSampleData = states;
const MSASampleData = new Array(13).fill({ name: "MSA", value: "MSA Value" });
const PropertyAssetTypesSampleData = Object.entries(PROPERTY_ASSET_TYPES).map(propertyType => ({ name: propertyType[0], value: propertyType[1] }));

export const PropertyCriteriaSampleFilters = [
  { filterName: "MSA", data: [...MSASampleData] },
  { filterName: "States", data: [...StatesSampleData] },
  { filterName: "Property Type", data: [...PropertyAssetTypesSampleData] }
];
